import { useCallback, useEffect, useState } from 'react';

import { fetchCurrentSubscription } from '../fetchers/currentSubscription';

/**
 * @param params
 * @param {string | null} params.clerkUserId
 * @param {boolean} [params.enabled]
 *
 * @returns {{
 *   data: { current_subscription: string} | null;
 *   loading: boolean;
 *   error: string | null;
 *   refetch: () => Promise<void>;
 * }}
 */
export function useCurrentSubscriptionQuery({ clerkUserId, enabled = true }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!clerkUserId) {
      return;
    }

    setLoading(true);

    try {
      const fetchedData = await fetchCurrentSubscription({ clerkUserId });
      setData(fetchedData);
    } catch {
      setError('An error occurred while fetching current subscription info.');
    } finally {
      setLoading(false);
    }
  }, [clerkUserId]);

  useEffect(() => {
    if (enabled) {
      fetchData();
    }
  }, [enabled, fetchData]);

  return {
    data,
    loading,
    error,
    refetch: fetchData,
  };
}
